import { parseToItems } from 'utils/parseToItems';

import useTranslation from 'components/fields/FarmSelectPanelField/hooks/useTranslation';

import useFarms from 'hooks/useFarms';
import useSelectPanelField from 'hooks/useSelectPanelField';

import { DEFAULT_PAGE_SIZE } from './constants';
import type { ParcelResponse } from './types';

const useData = (clientId?: string) => {
    const { fetch, isLoading, reset } = useFarms();
    const { NO_FARMS_FOUND, SELECT_A_CLIENT_TO_SEE_FARMS } = useTranslation();

    const fetchWithClientId = (args?: { name?: string; pageSize?: number }) =>
        fetch({
            clientId,
            name: args?.name,
            pageSize: args?.pageSize
        });

    const { handleAsyncFilter, hasNextPage, items, noItemsText, onNextPage } =
        useSelectPanelField<ParcelResponse>({
            dependency: clientId,
            dependencyRequiredText: SELECT_A_CLIENT_TO_SEE_FARMS,
            fetchFn: fetchWithClientId,
            noItemsFoundText: NO_FARMS_FOUND,
            pageSize: DEFAULT_PAGE_SIZE,
            parseFn: parseToItems,
            resetFn: reset
        });

    return {
        farmItems: items,
        handleAsyncFilter,
        hasNextPage,
        isLoading,
        noItemsText,
        onNextPage
    };
};

export default useData;
